import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import {
  COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE,
  COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE,
  UPDATE_COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE,
} from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE,
      method: 'put',
      request: (id, typeId, body, callback, t) => ({
        url: apiRoutes.communityIdentificationCodeTypes(id, typeId),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE,
            id: typeId,
            idProp: 'id',
          },
          setOther: {
            resource: COMMUNITY_IDENTIFICATION_CODE_TYPE_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateIdentificationCodeTypeFailed'),
            onSuccessMessage: t('updateIdentificationCodeTypeSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);
